var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogowithwhitetext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 36,
    viewBox: "0 0 125 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6618 23H41.1902L44.9562 12.0909H47.9285L51.6891 23H49.2175L46.4849 14.5838H46.3997L43.6618 23ZM43.5073 18.712H49.3454V20.5124H43.5073V18.712ZM62.1268 12.0909V23H60.1346L55.3885 16.1339H55.3086V23H53.0022V12.0909H55.0263L59.7351 18.9517H59.831V12.0909H62.1268ZM64.0324 23V12.0909H66.3389V16.9009H66.4827L70.4085 12.0909H73.1731L69.1248 16.9755L73.221 23H70.4618L67.4735 18.5149L66.3389 19.8999V23H64.0324ZM76.2546 23H73.783L77.549 12.0909H80.5213L84.2819 23H81.8103L79.0777 14.5838H78.9925L76.2546 23ZM76.1001 18.712H81.9382V20.5124H76.1001V18.712ZM91.2639 15.2283C91.2213 14.7987 91.0384 14.4648 90.7152 14.2269C90.3921 13.989 89.9535 13.87 89.3995 13.87C89.0231 13.87 88.7053 13.9233 88.4461 14.0298C88.1868 14.1328 87.988 14.2766 87.8495 14.4613C87.7145 14.646 87.6471 14.8555 87.6471 15.0898C87.64 15.2852 87.6808 15.4556 87.7696 15.6012C87.8619 15.7468 87.988 15.8729 88.1478 15.9794C88.3076 16.0824 88.4922 16.1729 88.7017 16.2511C88.9113 16.3256 89.135 16.3896 89.3729 16.4428L90.353 16.6772C90.8289 16.7837 91.2657 16.9258 91.6634 17.1033C92.0611 17.2809 92.4056 17.4993 92.6968 17.7585C92.988 18.0178 93.2135 18.3232 93.3733 18.6747C93.5366 19.0263 93.6201 19.4293 93.6236 19.8839C93.6201 20.5515 93.4496 21.1303 93.1123 21.6204C92.7784 22.1069 92.2955 22.4851 91.6634 22.755C91.0348 23.0213 90.2767 23.1545 89.3889 23.1545C88.5082 23.1545 87.7412 23.0195 87.0878 22.7496C86.4379 22.4798 85.9301 22.0803 85.5643 21.5511C85.2021 21.0185 85.0121 20.3597 84.9944 19.5749H87.2262C87.2511 19.9407 87.3559 20.2461 87.5405 20.4911C87.7287 20.7326 87.9791 20.9155 88.2916 21.0398C88.6076 21.1605 88.9645 21.2209 89.3623 21.2209C89.7529 21.2209 90.092 21.1641 90.3797 21.0504C90.6708 20.9368 90.8963 20.7788 91.0561 20.5763C91.2159 20.3739 91.2958 20.1413 91.2958 19.8786C91.2958 19.6335 91.2231 19.4276 91.0775 19.2607C90.9354 19.0937 90.7259 18.9517 90.4489 18.8345C90.1755 18.7173 89.8399 18.6108 89.4422 18.5149L88.2543 18.2166C87.3346 17.9929 86.6083 17.6431 86.0757 17.1673C85.543 16.6914 85.2784 16.0504 85.282 15.2443C85.2784 14.5838 85.4542 14.0067 85.8093 13.5131C86.168 13.0195 86.6598 12.6342 87.2848 12.3572C87.9098 12.0803 88.6201 11.9418 89.4155 11.9418C90.2252 11.9418 90.9319 12.0803 91.5356 12.3572C92.1428 12.6342 92.6151 13.0195 92.9525 13.5131C93.2898 14.0067 93.4638 14.5785 93.4745 15.2283H91.2639ZM105.2 17.5455C105.2 18.7351 104.974 19.7472 104.523 20.5817C104.076 21.4162 103.465 22.0536 102.691 22.494C101.92 22.9308 101.054 23.1491 100.092 23.1491C99.1221 23.1491 98.2521 22.929 97.4815 22.4886C96.7109 22.0483 96.1019 21.4109 95.6544 20.5763C95.207 19.7418 94.9833 18.7315 94.9833 17.5455C94.9833 16.3558 95.207 15.3438 95.6544 14.5092C96.1019 13.6747 96.7109 13.0391 97.4815 12.6023C98.2521 12.1619 99.1221 11.9418 100.092 11.9418C101.054 11.9418 101.92 12.1619 102.691 12.6023C103.465 13.0391 104.076 13.6747 104.523 14.5092C104.974 15.3438 105.2 16.3558 105.2 17.5455ZM102.861 17.5455C102.861 16.7749 102.746 16.125 102.515 15.5959C102.288 15.0668 101.967 14.6655 101.551 14.392C101.136 14.1186 100.649 13.9819 100.092 13.9819C99.534 13.9819 99.0475 14.1186 98.6321 14.392C98.2166 14.6655 97.8934 15.0668 97.6626 15.5959C97.4353 16.125 97.3217 16.7749 97.3217 17.5455C97.3217 18.3161 97.4353 18.9659 97.6626 19.495C97.8934 20.0241 98.2166 20.4254 98.6321 20.6989C99.0475 20.9723 99.534 21.109 100.092 21.109C100.649 21.109 101.136 20.9723 101.551 20.6989C101.967 20.4254 102.288 20.0241 102.515 19.495C102.746 18.9659 102.861 18.3161 102.861 17.5455ZM106.908 23V12.0909H114.131V13.9925H109.215V16.592H113.652V18.4936H109.215V23H106.908ZM115.267 13.9925V12.0909H124.227V13.9925H120.887V23H118.607V13.9925H115.267Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.85495 6.09444L4.21083 1.8522L5.85495 2.77884V6.09444Z",
    fill: "#FB9F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26199 4.66416L5.85495 6.09444V2.77884L9.26199 4.66416Z",
    fill: "#FC8334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78391 7.22988L5.85495 6.09444L9.26199 4.66416L8.78391 7.22988Z",
    fill: "#FF6107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1588 7.70796L8.78391 7.22988L9.26199 4.66416L10.1588 7.70796Z",
    fill: "#FF6107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5937 5.97492L10.1588 7.70796L9.26199 4.66416L11.5937 5.97492Z",
    fill: "#D30729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5064 6.99084L10.1588 7.70796L11.5937 5.97492L13.5064 6.99084Z",
    fill: "#E9290F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0011 9.56016C14.5227 9.56016 10.1588 7.70796 10.1588 7.70796L13.5068 6.99084L15.0011 9.56016Z",
    fill: "#FF6107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1093 9.56016H15.0011L13.5064 6.99084L18.1093 9.56016Z",
    fill: "#FF9142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4277 8.51544L11.4141 11.2331L8.72415 8.12628L10.4277 8.51544Z",
    fill: "#FF6107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8328 8.8362L11.4141 11.2331L10.4277 8.51544L11.8328 8.8362Z",
    fill: "#FF6107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5064 9.21888L11.4141 11.2331L11.8328 8.8362L13.5064 9.21888Z",
    fill: "#E9290F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0011 9.56016L11.4141 11.2331L13.5064 9.21888L15.0011 9.56016Z",
    fill: "#FF6201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5552 12.01L11.4141 11.2331L15.0011 9.56016L16.5552 12.01Z",
    fill: "#E9290F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0061 12.01H16.5552L15.0011 9.56016L19.0061 12.01Z",
    fill: "#FF6201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1093 9.56016L19.0061 12.01L15.0011 9.56016H18.1093Z",
    fill: "#C40018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3049 9.02232L20.0822 11.2331L18.1094 9.56016L19.3049 9.02232Z",
    fill: "#DE000B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0061 12.01L20.0822 11.2331L18.1094 9.56016L19.0061 12.01Z",
    fill: "#E8290D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3049 9.02232L20.0821 11.2331L19.7834 6.57252L19.3049 9.02232Z",
    fill: "#F34F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.289 6.57252H19.7834V4.75956L18.289 6.57252Z",
    fill: "#FF6107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7508 5.73624L17.3325 7.11036L18.289 6.57252L17.7508 5.73624Z",
    fill: "#FFC137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7834 4.75956L17.7508 5.73624L18.289 6.57252L19.7834 4.75956Z",
    fill: "#FC9A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.968 2.7486L19.7834 4.75956L22.6767 4.48128L23.968 2.7486Z",
    fill: "#FADA3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6767 4.48128L19.7834 4.75956L21.8757 5.55696L22.6767 4.48128Z",
    fill: "#FF922E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7834 6.57252L21.8757 5.55696L19.7834 4.75956V6.57252Z",
    fill: "#FFBB35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6091 9.56016L22.3537 8.96256L21.2302 11.2331L23.6091 9.56016Z",
    fill: "#F34F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6091 9.56016L26.2993 9.73944L27.973 7.0506L23.6091 9.56016Z",
    fill: "#FF9142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.973 7.0506L31.4639 7.70796L26.2993 9.73944L27.973 7.0506Z",
    fill: "#FF6107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5351 6.09444L32.649 7.22988L32.1875 4.78008L35.5351 6.09444Z",
    fill: "#FF6107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5949 2.81916L32.1875 4.7844L35.5351 6.09444L35.5949 2.81916Z",
    fill: "#FC8334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5352 6.09444L35.5949 2.81916L37.3222 1.86588L35.5352 6.09444Z",
    fill: "#FB9F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6176 0.0169201L35.5352 6.09444L37.3222 1.86588L40.6176 0.0169201Z",
    fill: "#FBB42F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4402 7.70796L29.9598 5.97492L27.9496 7.0506L31.4402 7.70796Z",
    fill: "#E9290F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1875 4.78008L29.9537 5.97492L31.4337 7.70796L32.1875 4.78008Z",
    fill: "#D30729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4355 7.70796L32.6508 7.22988L32.1893 4.78008L31.4355 7.70796Z",
    fill: "#E9290F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2076 12.01H16.5552L15.8975 14.4L13.2076 12.01Z",
    fill: "#F97D37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0061 12.01H16.5552L15.8975 14.4L19.0061 12.01Z",
    fill: "#FB5942"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5443 14.7586L20.0822 11.2331L19.0061 12.01L19.5443 14.7586Z",
    fill: "#FF6205"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8975 14.4L17.7749 14.5847L19.0061 12.01L15.8975 14.4Z",
    fill: "#F24421"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7749 14.5847L19.5443 14.7586L19.0061 12.01L17.7749 14.5847Z",
    fill: "#F24421"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5443 14.7586L20.6999 12.996L22.1147 14.7586H19.5443Z",
    fill: "#C40018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0822 11.2331L20.6999 12.996L19.5443 14.7586L20.0822 11.2331Z",
    fill: "#E8290D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8644 12.01L25.7612 14.3402L22.4196 12.01H24.8644Z",
    fill: "#C40018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2302 11.2331L22.4196 12.01L22.1147 14.7586L21.2302 11.2331Z",
    fill: "#C40018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6091 14.5872L25.7612 14.3402L22.4196 12.01L23.6091 14.5872Z",
    fill: "#FF6201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2994 9.73944L22.4196 12.01H24.8644L26.2994 9.73944Z",
    fill: "#E8290D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2994 9.73944L22.4196 12.01L23.6091 9.56016L26.2994 9.73944Z",
    fill: "#C40018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2302 11.2331L20.6999 12.996L20.0822 11.2331H21.2302Z",
    fill: "#C40018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1147 14.7586L20.6999 12.996L21.2302 11.2331L22.1147 14.7586Z",
    fill: "#E8290D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2302 11.2331L22.4196 12.01L23.6091 9.56016L21.2302 11.2331Z",
    fill: "#FF6201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3537 8.96256L21.8757 5.55696L21.2302 11.2331L22.3537 8.96256Z",
    fill: "#FB713B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0822 11.2331H21.2302L19.7834 6.57252L20.0822 11.2331Z",
    fill: "#FB713B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1147 14.7586L22.4196 12.01L23.6091 14.5872L22.1147 14.7586Z",
    fill: "#E8290D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3913 12.01L25.7611 14.3402L24.8644 12.01H28.3913Z",
    fill: "#F97D37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2993 9.73944L24.8644 12.01L30.1251 11.2928L26.2993 9.73944Z",
    fill: "#C40018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7552 8.06652L30.1251 11.2928L31.0229 8.51544L32.7552 8.06652Z",
    fill: "#FC8334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2993 9.73944L30.1251 11.2928L28.212 9.24372L26.2993 9.73944Z",
    fill: "#FC6146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0229 8.51544L29.7841 8.8362L30.1251 11.2928L31.0229 8.51544Z",
    fill: "#E8290D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.212 9.24372L29.7842 8.8362L30.1251 11.2928L28.212 9.24372Z",
    fill: "#C40018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85495 6.09444L0.833313 0L4.21083 1.8522L5.85495 6.09444Z",
    fill: "#FBB42F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7834 6.57252L21.8757 5.55696L21.2302 11.2331L19.7834 6.57252Z",
    fill: "#FFA12B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5443 14.7586L19.6937 15.655L20.656 14.7586H19.5443Z",
    fill: "#EA2711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8757 15.5653L20.656 14.7586H22.1147L21.8757 15.5653Z",
    fill: "#EA2711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6937 15.655L20.8295 17.2681L20.656 14.7586L19.6937 15.655Z",
    fill: "#FB6145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8757 15.5653L20.8295 17.2681L20.656 14.7586L21.8757 15.5653Z",
    fill: "#FB6145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8878 21.3955L18.7221 28.1128L18.1094 25.7951L19.8878 21.3955Z",
    fill: "#861694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8295 17.2688L18.9464 19.0339L19.6937 15.655L20.8295 17.2688Z",
    fill: "#FD1A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1094 25.7951L17.7508 24.4382L19.8878 21.3955L18.1094 25.7951Z",
    fill: "#9B0B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9464 19.0332L20.1221 20.0466L20.8295 17.2681L18.9464 19.0332Z",
    fill: "#CE1561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7508 24.4382L18.6774 20.2493L19.8878 21.3955L17.7508 24.4382Z",
    fill: "#CA187A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9464 19.0332L19.8878 21.3955L20.1221 20.0466L18.9464 19.0332Z",
    fill: "#DF2858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6774 20.2493L18.9464 19.0332L19.8878 21.3955L18.6774 20.2493Z",
    fill: "#B8177E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8295 17.2681L22.8621 19.706L21.8757 15.5653L20.8295 17.2681Z",
    fill: "#FD1A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1221 20.0466L20.8594 23.004L19.3726 25.7951L20.1221 20.0466Z",
    fill: "#D41477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8295 17.2681L22.8621 19.706L21.4973 20.0099L20.8295 17.2681Z",
    fill: "#CE1561"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8066 28.0897L21.8278 22.0486L23.5111 25.8196L22.8066 28.0897Z",
    fill: "#861694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8621 19.706L21.8278 22.0486L23.1288 20.826L22.8621 19.706Z",
    fill: "#B8177E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5111 25.8196L23.9619 24.3486L21.8278 22.0486L23.5111 25.8196Z",
    fill: "#9B0B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1288 20.826L23.968 24.3486L21.8278 22.0486L23.1288 20.826Z",
    fill: "#CA187A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3726 25.7951L18.7671 30.443L20.8594 23.004L19.3726 25.7951Z",
    fill: "#B8177E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4973 20.0099L20.8594 23.004L22.308 26.7235L21.4973 20.0099Z",
    fill: "#D41477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.308 26.7235L18.7671 30.443L22.488 28.5833L22.308 26.7235Z",
    fill: "#B71F8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6767 30.5327L20.8594 31.7279L22.488 28.5833L22.6767 30.5327Z",
    fill: "#8A1691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6767 30.5327L20.6999 36L20.8594 31.7279L22.6767 30.5327Z",
    fill: "#C2197C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7671 30.443L20.6999 36L20.8594 31.7279L18.7671 30.443Z",
    fill: "#951792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.308 26.7235L18.7671 30.443L20.8594 23.004L22.308 26.7235Z",
    fill: "#7F0A58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1221 20.0466L20.8594 23.004L21.4973 20.0099L20.1221 20.0466Z",
    fill: "#7F0A58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8295 17.2681L21.4973 20.0099L20.1221 20.0466L20.8295 17.2681Z",
    fill: "#B8177D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7671 30.4394L20.8594 31.7279L22.488 28.5833L18.7671 30.4394Z",
    fill: "#C2197C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8472 21.946L21.741 21.3908L22.8621 19.7057L21.8472 21.946Z",
    fill: "#134955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4973 20.0099L21.7252 21.415L22.8621 19.7057L21.4973 20.0099Z",
    fill: "#DF2858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8278 22.0486L21.7252 21.415L22.8621 19.7057L21.8278 22.0486Z",
    fill: "#DF2858"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.7843,
    height: 36,
    fill: "white",
    transform: "translate(0.833313)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogowithwhitetext);
export default __webpack_public_path__ + "static/media/logowithwhitetext.85b794ed151f9170a8ed31bba2c1ea5c.svg";
export { ForwardRef as ReactComponent };